import common from './zh-CN/common';
import datasets from './zh-CN/datasets';
import datasetsDetail from './zh-CN/datasets.detail';
import docs from './zh-CN/docs';
import feedback from './zh-CN/feedback';
import footer from './zh-CN/footer';
import home from './zh-CN/home';
import material from './zh-CN/material';
import nav from './zh-CN/nav';
import user from './zh-CN/user';
import apply from './zh-CN/applydownload';
import downloadModal from './zh-CN/download-modal';
import guide from './zh-CN/guide';
import aboutUs from './zh-CN/aboutUs';
import modelscope from './zh-CN/modelscope';
import extractor from './zh-CN/extractor';
import smallLanguageZh from './zh-CN/small-language';
import wanjuan from './zh-CN/wanjuan';

export default {
  ...nav,
  ...footer,
  ...user,
  ...common,
  ...home,
  ...datasets,
  ...datasetsDetail,
  ...docs,
  ...feedback,
  ...material,
  ...apply,
  ...downloadModal,
  ...guide,
  ...aboutUs,
  ...modelscope,
  ...extractor,
  ...smallLanguageZh,
  ...wanjuan,
};
